import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ViewMessage.css';
import styled from 'styled-components';
import { colors } from '../../tailwind';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import ChatScreen from '../../components_new/Inbox/ChatScreen';
import { Grid, Row, Col } from 'react-bootstrap';
import { sendMessageAction } from '../../actions/message/sendMessageAction';

import AllThreadsQuery from './AllThreadsQuery.graphql';

// Redux Action
import { readMessage } from '../../actions/message/readMessage';

class ViewMessageContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    userType: PropTypes.string.isRequired,
  };

  onToggleData() {
    this.setState(prevState => ({
      mockData: !prevState.mockData,
    }));
  }

  approve = (params, thread, reservationId) => {
    const { sendMessageAction } = this.props;
    // startDate,
    //   endDate,
    //   reservation,
    // pickupTime: this.selectedPickupTime,
    // returnTime: this.selectedReturnTime,
    //   pickupAddress: this.pickupAddress,
    //     returnAddress
    sendMessageAction(
      thread.id,
      'host',
      null,
      'approved',
      params.pickupDay,
      params.returnDay,
      reservationId,
      params.pickupAddress,
      params.returnAddress,
      params.pickupTime,
      params.returnTime,
    );
  };

  render() {
    const { userId, allThreads, readMessage, focusedThread } = this.props;

    return (
      <div className={s.container}>
        <div className={s.root}>
          <ChatScreen
            userId={userId}
            threads={allThreads}
            readMessage={readMessage}
            focusedThread={focusedThread}
            approve={this.approve}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userId: state.account.data && state.account.data.userId,
  };
}

export default compose(
  withStyles(s),
  connect(
    mapStateToProps,
    { readMessage, sendMessageAction },
  ),
  graphql(AllThreadsQuery, {
    name: 'allThreads',
    options: {
      ssr: false,
    },
  }),
)(ViewMessageContainer);



// WEBPACK FOOTER //
// ./src/routes/viewMessage/ViewMessageContainer.js